module.exports = __webpack_public_path__ + "teqbahn-assets/media/Slide3.397c1bb2.gif";